import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://multi-counter.bancheng.tech/api';

/**
 * Get all displays
 */
export const getAllDisplays = async () => {
  try {
    const response = await axios.get(`${API_URL}/displays`);
    return response.data;
  } catch (error) {
    console.error('Error getting all displays:', error);
    throw error;
  }
};

/**
 * Get displays by company ID
 */
export const getDisplaysByCompany = async (companyId) => {
  try {
    const response = await axios.get(`${API_URL}/displays/company/${companyId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting displays by company:', error);
    throw error;
  }
};

/**
 * Get display by ID
 */
export const getDisplay = async (displayId) => {
  try {
    const response = await axios.get(`${API_URL}/displays/${displayId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting display:', error);
    throw error;
  }
};

/**
 * Create or update display (upsert)
 */
export const upsertDisplay = async (displayData) => {
  try {
    const payload = {
      '名稱': displayData.deviceName || displayData.名稱,
      '公司ID': displayData.companyId || displayData.公司ID,
      '🔒 Row ID': displayData.id || displayData['🔒 Row ID'],
      '回傳連結': displayData.callbackUrl || displayData.回傳連結,
      'Bearer Token': displayData.bearerToken || displayData['Bearer Token']
    };

    console.log('📤 Sending upsert request with payload:', payload);
    const response = await axios.post(`${API_URL}/displays/upsert`, payload);
    console.log('📥 Received response:', response.data);
    console.log('📥 Display data:', response.data.display);
    console.log('📥 Display 顯示器連結:', response.data.display?.顯示器連結);
    return response.data.display;
  } catch (error) {
    console.error('Error upserting display:', error);
    throw error;
  }
};

/**
 * Create display (wrapper for upsert without ID)
 */
export const createDisplay = async (displayData) => {
  return upsertDisplay({
    名稱: displayData.deviceName,
    公司ID: displayData.companyId,
    '🔒 Row ID': displayData.deviceCode || undefined,  // 使用用戶填寫的設備代碼作為 ID
    回傳連結: displayData.callbackUrl || undefined,
    'Bearer Token': displayData.bearerToken || undefined
  });
};

/**
 * Update display (wrapper for upsert with ID)
 */
export const updateDisplay = async (displayId, updates) => {
  return upsertDisplay({
    '🔒 Row ID': displayId,
    名稱: updates.deviceName,
    公司ID: updates.companyId,
    回傳連結: updates.callbackUrl,
    'Bearer Token': updates.bearerToken
  });
};

/**
 * Delete display
 */
export const deleteDisplay = async (displayId) => {
  try {
    await axios.delete(`${API_URL}/displays/${displayId}`);
    return { success: true, displayId };
  } catch (error) {
    console.error('Error deleting display:', error);
    throw error;
  }
};

/**
 * Subscribe to all displays (polling implementation)
 */
export const subscribeToAllDisplays = (callback) => {
  const fetchData = async () => {
    try {
      const displays = await getAllDisplays();
      callback(displays);
    } catch (error) {
      console.error('Error fetching displays:', error);
    }
  };

  // Initial fetch
  fetchData();

  // Poll every 5 seconds
  const intervalId = setInterval(fetchData, 5000);

  // Return cleanup function
  return () => clearInterval(intervalId);
};

// Backward compatibility aliases
export const getAllDevices = getAllDisplays;
export const getDevicesByCompany = getDisplaysByCompany;
export const getDevice = getDisplay;
export const createDevice = createDisplay;
export const updateDevice = updateDisplay;
export const deleteDevice = deleteDisplay;
export const subscribeToAllDevices = subscribeToAllDisplays;
